import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/calendar-icon.svg'
import _imports_1 from '@/assets/gray-user.svg'
import _imports_2 from '@/assets/pencil-gray.svg'


const _hoisted_1 = { class: "flex flex-col gap-3 relative p-3 pt-0" }
const _hoisted_2 = {
  key: 0,
  class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col gap-3"
}
const _hoisted_5 = {
  key: 3,
  class: "flex flex-col gap-3"
}
const _hoisted_6 = { class: "w-full flex items-center justify-between" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = { class: "flex items-center gap-1" }
const _hoisted_9 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_10 = { class: "flex items-center gap-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "text-base font-normal text-" }
const _hoisted_15 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_16 = { class: "text-base font-normal text-" }
const _hoisted_17 = {
  key: 4,
  class: "flex gap-1"
}
const _hoisted_18 = { class: "w-full flex items-center justify-between" }
const _hoisted_19 = { class: "flex items-center gap-3" }
const _hoisted_20 = { class: "flex items-center gap-1" }
const _hoisted_21 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_22 = { class: "flex items-center gap-1" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "mt-4 flex gap-2" }
const _hoisted_26 = { class: "text-base font-normal grow" }
const _hoisted_27 = { class: "px-3 py-[1px] rounded-primary-radius bg-[#e5ecf6] mt-2 h-fit w-fit" }
const _hoisted_28 = { class: "text-base font-normal h-fit w-fit" }
const _hoisted_29 = {
  key: 5,
  class: "flex flex-col gap-3"
}
const _hoisted_30 = { class: "w-full flex items-center justify-between" }
const _hoisted_31 = { class: "flex items-center gap-3" }
const _hoisted_32 = { class: "flex items-center gap-1" }
const _hoisted_33 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_34 = { class: "flex items-center gap-1" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "mt-4" }
const _hoisted_38 = { class: "text-base font-normal text-" }
const _hoisted_39 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_40 = { class: "text-base font-normal text-" }

import { ref, computed } from "vue";
import InputModal from "../InputModal.vue";
import SlideImagesBlock from "./SlideImagesBlock.vue";
import CheckListBlock from "./CheckListBlock.vue";
import AddImageModal from "../AddImageModal.vue";
import { transformSlug } from "@/utils/transformSlug";
import CustomAccordion from "./CustomAccordion.vue";
import RepeatableInput from "./RepeatableInput.vue";

type Props = {
  input: any;
  childInputs: any;
  project: string | string[];
  phase: number;
  phaseDetails: any;
  step: any;
  selectedTermins: any;
  showDetails?: boolean;
};
type Emits = {
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'RepeatableGroupInput',
  props: {
    input: {},
    childInputs: {},
    project: {},
    phase: {},
    phaseDetails: {},
    step: {},
    selectedTermins: {},
    showDetails: { type: Boolean }
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

let repeatableGroupNames = computed(() => {
  if (props.input) {
    let groupNames = [];
    if (
      props.input.repeatableGroupDetails &&
      props.input.repeatableGroupDetails.length > 0 &&
      !props.input.isConditionallyRepetable
    ) {
      groupNames = props.input.repeatableGroupDetails.map((item: any) => {
        return {
          id: item.id,
          name: `${transformSlug(props.input.projectReference)}: ${item.name}`,
          image: item.image,
          order: item.order,
        };
      });

      return groupNames;
    } else if (props.input.isConditionallyRepetable) {
      groupNames = props.input.repeatableGroupDetails.map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          image: null,
          order: item.order,
        };
      });

      return groupNames;
    } else {
      for (let index = 0; index < props.input.repeatCounter; index++) {
        groupNames.push({
          id: index + 1,
          name: `${transformSlug(props.input.projectReference)}: ${
            props.input.repeatableInputNoun
          } ${index + 1}`,
          order: index + 1,
        });
      }
      return groupNames;
    }
  }
  return [];
});

const isInputModalOpen = ref(false);
const isAddImageModalOpen = ref(false);
const selectedInput = ref<any>(null);
const selectedStep = ref<any>(null);
const selectedInputGroupIndex = ref<any>(null);
const selectedInputIndex = ref<any>(null);

const toggleModalHandler: any = (
  input: any,
  step: any,
  inputIndex?: number,
  groupIndex?: number
) => {
  selectedInput.value = input;
  selectedStep.value = step;
  isInputModalOpen.value = !isInputModalOpen.value;
  selectedInputGroupIndex.value = groupIndex;
  selectedInputIndex.value = inputIndex;
};

/** Resolve display label for select/static_select inside repeatable groups.
 *  Handles value being an option ID (number/string) OR the option text itself. */
function getSelectDisplayLabel(input: any): string {
  if (input?.value == null || input?.value === "") return "";
  const val = input.value;
  const opts = input.options;
  if (!opts || !Array.isArray(opts)) return String(val);
  // Try matching by id (numeric or string)
  const byId = opts.find(
    (opt: any) =>
      Number(opt.id) === Number(val) || String(opt.id) === String(val)
  );
  if (byId) return String(byId.option ?? byId.name ?? val);
  // Try matching by option text (backend sometimes stores the text as value)
  const byText = opts.find(
    (opt: any) =>
      String(opt.option ?? "").toLowerCase() === String(val).toLowerCase() ||
      String(opt.name ?? "").toLowerCase() === String(val).toLowerCase()
  );
  if (byText) return String(byText.option ?? byText.name ?? val);
  return String(val);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isInputModalOpen.value && selectedInput.value)
      ? (_openBlock(), _createBlock(InputModal, {
          key: 0,
          input: selectedInput.value,
          step: selectedStep.value,
          "is-open": isInputModalOpen.value,
          project: __props.project,
          phase: __props.phase,
          termins: __props.phaseDetails.termins,
          "group-index": selectedInputGroupIndex.value,
          "input-index": selectedInputIndex.value,
          onRefresh: _cache[0] || (_cache[0] = () => emits('refresh')),
          onToggleModal: _cache[1] || (_cache[1] = 
      () => {
        isInputModalOpen.value = false;
        selectedInput.value = null;
      }
    )
        }, null, 8, ["input", "step", "is-open", "project", "phase", "termins", "group-index", "input-index"]))
      : _createCommentVNode("", true),
    (isAddImageModalOpen.value && selectedInput.value)
      ? (_openBlock(), _createBlock(AddImageModal, {
          key: 1,
          steps: __props.phaseDetails.steps,
          termins: __props.phaseDetails.termins,
          "is-open": isAddImageModalOpen.value,
          project: __props.project,
          input: selectedInput.value,
          step: selectedStep.value,
          "header-title": selectedInput.value ? selectedInput.value.name : '',
          phase: __props.phase,
          "group-index": selectedInputGroupIndex.value,
          "input-index": selectedInputIndex.value,
          onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (isAddImageModalOpen.value = false)),
          onRefresh: _cache[3] || (_cache[3] = () => emits('refresh'))
        }, null, 8, ["steps", "termins", "is-open", "project", "input", "step", "header-title", "phase", "group-index", "input-index"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(repeatableGroupNames), (detail) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "bg-[#E5E4E2] rounded-primary-radius",
          key: detail.id
        }, [
          (__props.childInputs.some(
          (input) =>
            input.repeatableGroupIndex + 1 === detail.order &&
            ((input.value && input.value.length > 0) || input.finishedInputs > 0)
        ))
            ? (_openBlock(), _createBlock(CustomAccordion, {
                key: 0,
                "step-name": detail.name,
                "header-image": detail.image,
                "accordion-header-color": "#E5E4E2",
                "sticky-height": `${
          __props.showDetails ? 'top-[383px]' : 'top-[180px]'
        } sticky z-[16]`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (__props.childInputs.some((input) => input.type === 'checkbox' && input.repeatableGroupIndex+1 === detail.order))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(CheckListBlock, {
                            checklist: __props.childInputs.filter((input) => input.type === 'checkbox' && input.repeatableGroupIndex+1 === detail.order)
                          }, null, 8, ["checklist"])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.childInputs.some((input) => input.type === 'image' && input.repeatableGroupIndex+1 === detail.order && input.value?.length > 0))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => input.type === 'image' && input.repeatableGroupIndex+1 === detail.order && input.value?.length > 0), (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "flex flex-col gap-1"
                            }, [
                              _createVNode(SlideImagesBlock, {
                                "is-group": true,
                                "show-details": __props.showDetails,
                                "selected-termins": __props.selectedTermins,
                                "header-class": `${
                  __props.showDetails ? 'top-[363px]' : 'top-[163px]'
                } sticky z-[15]`,
                                onAddImageModalOpen: 
                  () => {
                    selectedInput.value = item;
                    selectedStep.value = __props.step;
                    isAddImageModalOpen.value = true;
                    selectedInputGroupIndex.value = detail.order - 1;
                  }
                ,
                                input: item,
                                step: __props.step,
                                "repeatable-group-detail": detail,
                                steps: __props.phaseDetails.steps,
                                refresh: () => emits('refresh')
                              }, null, 8, ["show-details", "selected-termins", "header-class", "onAddImageModalOpen", "input", "step", "repeatable-group-detail", "steps", "refresh"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (__props.childInputs.some((input) => input.type === 'repeatable_input' && input.finishedInputs > 0))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => input.type === 'repeatable_input' && input.finishedInputs > 0), (childInput) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: childInput.id,
                              class: ""
                            }, [
                              _createVNode(RepeatableInput, {
                                showDetails: __props.showDetails,
                                selectedTermins: __props.selectedTermins,
                                step: __props.step,
                                input: childInput,
                                project: __props.project,
                                phaseDetails: __props.phaseDetails,
                                phase: __props.phase,
                                onRefresh: _cache[4] || (_cache[4] = () => emits('refresh'))
                              }, null, 8, ["showDetails", "selectedTermins", "step", "input", "project", "phaseDetails", "phase"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (__props.childInputs.some((input) => input.type === 'text' && input.repeatableGroupIndex+1 === detail.order && input.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => input.type === 'text' && input.repeatableGroupIndex+1 === detail.order && input.value), (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow flex flex-col gap-2"
                            }, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("div", _hoisted_8, [
                                    _cache[5] || (_cache[5] = _createElementVNode("img", {
                                      class: "w-3 h-3 cursor-pointer",
                                      src: _imports_0,
                                      alt: "Calendar"
                                    }, null, -1)),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(item.createdAt
                          ? new Date(item.createdAt).toLocaleDateString("de")
                          : ""), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_10, [
                                    _cache[6] || (_cache[6] = _createElementVNode("img", {
                                      class: "w-3 h-3",
                                      src: _imports_1,
                                      alt: "User"
                                    }, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.workers, (worker, index) => {
                                      return (_openBlock(), _createElementBlock("p", {
                                        key: index,
                                        class: "text-sm text-[#898790] foont-medium"
                                      }, [
                                        _createTextVNode(_toDisplayString(worker.fullname), 1),
                                        (index < item.workers.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, ","))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("img", {
                                  onClick: ($event: any) => (
                    toggleModalHandler(item, __props.step, null, detail.order - 1)
                  ),
                                  class: "w-4 h-4 cursor-pointer",
                                  src: _imports_2,
                                  alt: "Pencil"
                                }, null, 8, _hoisted_12)
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("p", _hoisted_14, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("p", _hoisted_16, _toDisplayString(item.value), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (__props.childInputs.some((input) => input.type === 'number' && input.repeatableGroupIndex+1 === detail.order && input.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => input.type === 'number' && input.repeatableGroupIndex+1 === detail.order && input.value), (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "p-3 w-1/3 bg-white rounded-primary-radius shadow-primary-box-shadow"
                            }, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, [
                                    _cache[7] || (_cache[7] = _createElementVNode("img", {
                                      class: "w-3 h-3 cursor-pointer",
                                      src: _imports_0,
                                      alt: "Calendar"
                                    }, null, -1)),
                                    _createElementVNode("p", _hoisted_21, _toDisplayString(item.createdAt
                          ? new Date(item.createdAt).toLocaleDateString("de")
                          : ""), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _cache[8] || (_cache[8] = _createElementVNode("img", {
                                      class: "w-3 h-3",
                                      src: _imports_1,
                                      alt: "User"
                                    }, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.workers, (worker, index) => {
                                      return (_openBlock(), _createElementBlock("p", {
                                        key: index,
                                        class: "text-sm text-[#898790] font-medium"
                                      }, [
                                        _createTextVNode(_toDisplayString(worker.fullname), 1),
                                        (index < item.workers.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, ","))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("img", {
                                  onClick: ($event: any) => (
                    toggleModalHandler(item, __props.step, null, detail.order - 1)
                  ),
                                  class: "w-4 h-4 cursor-pointer",
                                  src: _imports_2,
                                  alt: "Pencil"
                                }, null, 8, _hoisted_24)
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("p", _hoisted_26, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("p", _hoisted_28, _toDisplayString(item.value), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (__props.childInputs.some((input) => (input.type === 'select' || input.type === 'static_select') && input.repeatableGroupIndex+1 === detail.order && input.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.childInputs.filter((input) => (input.type === 'select' || input.type === 'static_select') && input.repeatableGroupIndex+1 === detail.order && input.value), (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow flex flex-col gap-2"
                            }, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _cache[9] || (_cache[9] = _createElementVNode("img", {
                                      class: "w-3 h-3 cursor-pointer",
                                      src: _imports_0,
                                      alt: "Calendar"
                                    }, null, -1)),
                                    _createElementVNode("p", _hoisted_33, _toDisplayString(item.createdAt
                          ? new Date(item.createdAt).toLocaleDateString("de")
                          : ""), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _cache[10] || (_cache[10] = _createElementVNode("img", {
                                      class: "w-3 h-3",
                                      src: _imports_1,
                                      alt: "User"
                                    }, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.workers, (worker, index) => {
                                      return (_openBlock(), _createElementBlock("p", {
                                        key: index,
                                        class: "text-sm text-[#898790] foont-medium"
                                      }, [
                                        _createTextVNode(_toDisplayString(worker.fullname), 1),
                                        (index < item.workers.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, ","))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("img", {
                                  onClick: ($event: any) => (
                    toggleModalHandler(item, __props.step, null, detail.order - 1)
                  ),
                                  class: "w-4 h-4 cursor-pointer",
                                  src: _imports_2,
                                  alt: "Pencil"
                                }, null, 8, _hoisted_36)
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("p", _hoisted_38, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("p", _hoisted_40, _toDisplayString(getSelectDisplayLabel(item)), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["step-name", "header-image", "sticky-height"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})